import { render, staticRenderFns } from "./IconTrashCross.vue?vue&type=template&id=6c2d099e&"
import script from "./IconTrashCross.vue?vue&type=script&lang=js&"
export * from "./IconTrashCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports